const MAIN_CAROUSEL_OPTIONS = {
  arrows: false,
  rewind: true,
  autoplay: true,
  interval: 4000,
  lazyload: true,
  speed: 1000,
  rewindSpeed: 500,
  gap: '0.5em'
}

export const carouselConfig = {
  main_carousel_options: MAIN_CAROUSEL_OPTIONS
}
